export enum FormSaveTypeEnum {
  PerStep = 'perStep',
  PerField = 'perField',
}
